module.exports = __webpack_public_path__ + "img/moon-over-sun.b56dc093.svg";